import React from 'react';
import BlockContent from '@sanity/block-content-to-react';
import { css } from '@emotion/core';
import tw from 'twin.macro';

export default function Content({ content, serializers, small, className }) {
  return (
    <div
      className={className}
      css={[
        tw`prose max-w-none lg:prose-xl`,
        css`
          margin: ${small ? 'auto' : '5vh auto !important'};
          a {
            text-decoration: none;
            color: inherit;
            position: relative;
            cursor: pointer;

            &::after {
              content: ' ';
              position: absolute;
              z-index: -1;
              top: 100%;
              left: -2px;

              padding: 0 2px;
              width: calc(100% + 3px);
              height: 2px;
              border-bottom: 2px solid rgba(252, 173, 58, 1);

              transition: 0.4s;
            }
            &:hover::after {
              top: 0;
              height: 1.5em;
              background-color: rgba(252, 173, 58, 1);
              border-color: transparent;
            }
          }
        `,
        css,
      ]}
    >
      <BlockContent
        blocks={content}
        projectId="eivsv947"
        dataset="development"
        serializers={serializers}
        imageOptions={{ w: 640, h: 480, fit: 'max' }}
      />
    </div>
  );
}
